import { Box, Modal, TextField, IconButton, Button, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Delete, Add } from "@mui/icons-material";
import deletebin from '../assets/icons/deletebin.svg';

const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    height: "90vh",
    minWidth: "300px",
    minHeight: "300px",
    maxWidth: "90vw",
    maxHeight: "200vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 2,
    resize: "both",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
};

interface select {
    id: number | null;
    name: string;
    description: string
}

interface ReminderModalProps {
    //token: string;
    open: boolean;
    onClose: () => void;
    list: select[];
    setList: (list: select[]) => void;
}

const ReminderModal = ({ open, onClose, list, setList }: ReminderModalProps) => {
    const [functions, setFunctions] = useState<select[]>([]);
    const [changedFunctions, setChangedFunctions] = useState<select[]>([]);
    const [deletedIds, setDeletedIds] = useState<number[]>([]);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    useEffect(() => {
        setFunctions(list || []);
        setDeletedIds([]);
    }, [list]);

    const handleChange = (index: number, value: string) => {
        const updated = [...functions];
        updated[index] = { ...updated[index], name: value };

      setChangedFunctions(prev => {

        const exists = prev.some(item => item.id === functions[index].id);

        if (exists) {
          return prev.map(item =>
            item.id === functions[index].id ? { ...item, name: value } : item
          );
        } else {
          return [...prev, updated[index]];
        }
      });

        setFunctions(updated);
        setActiveIndex(index);
    };

    const handleAdd = () => {
        if (functions.some(f => f.name.trim() === "")) return;
        setFunctions([...functions, { id: null, name: "", description: "" }]);
    };

    const markForDelete = (index: number) => {
        const item = functions[index];
        if (item.id != null) {
            setDeletedIds(prev => [...prev, item.id as number]);
        }
        setFunctions(prev => prev.filter((_, i) => i !== index));
    };

    const handleDescriptionChange = (index: number, value: string) => {
        const updated = [...functions];
        updated[index] = { ...updated[index], description: value };

      setChangedFunctions(prev => {

        const exists = prev.some(item => item.id === functions[index].id);

        if (exists) {
          return prev.map(item =>
            item.id === functions[index].id ? { ...item, description: value } : item
          );
        } else {
          return [...prev, updated[index]];
        }
      });

        setFunctions(updated);
        setActiveIndex(index);
    };




    const hasChanges = () => {
        if (deletedIds.length > 0) return true;
        if (functions.length !== list.length) return true;
        return functions.some((f, i) => f.name.trim() !== (list[i]?.name?.trim() || false)) || functions.some((f, i) => f.description.trim() !== (list[i]?.description?.trim() || false));
    };

    const hasErrorsOrNoChanges = () => {
        const trimmedNames = functions.map(f => f.name.trim());
        const trimmedDescriptions = functions.map(f => f.description.trim());

        const hasEmptyName = trimmedNames.some(name => name === "");
        const hasEmptyDescription = trimmedDescriptions.some(desc => desc === "");
        const hasDuplicates = trimmedNames.some((name, i) =>
            trimmedNames.indexOf(name) !== i && name !== ""
        );

        return !hasChanges() || hasEmptyName || hasEmptyDescription || hasDuplicates;
    };


    const handleOnClose = () => {
        //setChangedFunctions([]);
        //setFunctions(list || []);
        onClose()
    }

    const handleSave = async () => {
        const newFunctions = functions.filter(f => f.name.trim() !== "" && f.id === null);
        const uniqueDeletedIds = Array.from(new Set(deletedIds));

        try {
            const defaultHeadersParts = {
                //Authorization: `Token ${token}`, 
                Accept: 'application/json'
            };
            const defaultRequestParts = { method: 'GET', headers: { ...defaultHeadersParts } };
            const deletePromises = uniqueDeletedIds.map(id =>
                fetch(`/api/v0/reminder/${id}`, {
                    ...defaultRequestParts,
                    method: "DELETE",
                    credentials: 'include',
                }).then(res => {
                    if (!res.ok && res.status !== 404) {
                        throw new Error(`Errore nella cancellazione ID ${id}`);
                    }
                })
            );
            const updatePromises = changedFunctions.map(s =>
                fetch(`/api/v0/reminder/${s.id}`, {
                    method: "PATCH",
                    headers: {
                        ...defaultHeadersParts,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(s),
                    credentials: 'include',
                }).then(res => {
                    if (!res.ok && res.status !== 404) {
                        throw new Error(`Errore nella cancellazione ID ${s.id}`);
                    }
                })
            );
            const createPromises = newFunctions.map(func =>
                fetch("/api/v0/reminders", {
                    method: "POST",
                    headers: {
                        ...defaultHeadersParts,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(func),
                    credentials: 'include',
                }).then(res => {
                    if (!res.ok) throw new Error(`Errore nel salvataggio funzione: ${func.name}`);
                })
            );

            handleOnClose();
            await Promise.all([...deletePromises, ...updatePromises, ...createPromises]);
            const response = await fetch("/api/v0/reminders", {
                method: "GET",
                headers: defaultHeadersParts,
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error("Errore nel recupero delle funzioni aggiornate.");
            }

            const updatedFunctions = await response.json();
            setList(updatedFunctions)
            //console.log("Tutte le modifiche sono state salvate con successo.");
        } catch (error) {
            console.error("Errore nel salvataggio:", error);
        }
    };

    return (
        <Modal open={open} onClose={handleOnClose}>
            <Box sx={style}>

                <div className="row mb-3" style={{ flexShrink: 0 }}>
                    <div className="col text-start">
                        <h5 className="modal-title" style={{ whiteSpace: 'nowrap' }}>Gestisci lista dei reminder</h5>
                    </div>
                    <div className="col text-end">
                        <button type="button" className="btn-close" onClick={handleOnClose}></button>
                    </div>
                </div>

                <Stack spacing={2}
                    sx={{
                        flexGrow: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        overflowX: "hidden",
                    }}>
                    {functions.map((func, index) => {
                        const nameTrimmed = func.name.trim();
                        const isDuplicate =
                            functions.filter((f, i) => f.name.trim() === nameTrimmed && i !== index).length > 0;
                        const showError = activeIndex === index && (nameTrimmed === "" || isDuplicate);

                        return (
                            <Box key={`${func.id ?? `new-${index}`}`} display="flex" flexDirection="column" gap={1} sx={{ background: '#F3F3F3', padding: 2 }}>
                                <div className="row">
                                    <div className="col-10">

                                        <TextField
                                            fullWidth
                                            sx={{ maxWidth: '100%' }}
                                            label="Nome"
                                            value={func.name}
                                            onChange={(e) => handleChange(index, e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            error={showError}
                                            inputProps={{ maxLength: 35 }}
                                            FormHelperTextProps={{ style: { textAlign: 'right' } }}
                                            helperText={
                                                showError
                                                    ? nameTrimmed === ""
                                                        ? "Il nome non può essere vuoto"
                                                        : "Nome duplicato"
                                                    : `${func.name.length}/35`
                                            }
                                        />
                                        <TextField
                                            fullWidth
                                            multiline
                                            sx={{ maxWidth: '100%' }}
                                            label="Nome vocale"
                                            rows={2}
                                            value={func.description}
                                            onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ maxLength: 130 }}
                                            error={activeIndex === index && func.description.trim() === ""}
                                            helperText={

                                                activeIndex === index && func.description.trim() === ""
                                                    ? "La nome vocale non può essere vuota"
                                                    : `${func.description.length}/130`
                                            }
                                            FormHelperTextProps={{ style: { textAlign: 'right' } }}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <IconButton onClick={() => markForDelete(index)} color="error">
                                            <img src={deletebin} alt="icon" width={30} />
                                        </IconButton>
                                    </div>
                                </div>
                            </Box>

                        );
                    })}


                </Stack>
                <Box display="flex" justifyContent="center" mt={2} sx={{ flexShrink: 0 }}>
                    <button className="btn btn-light" onClick={handleAdd}>
                        Inserisci nuovo <Add fontSize="small" />
                    </button>
                </Box>
                <Box mt={4} display="flex" justifyContent="flex-end" gap={2} sx={{ flexShrink: 0, marginBottom: 2 }}>
                    <button className="btn btn-light" onClick={handleOnClose}>Annulla</button>
                    <button
                        className="btn btn-success"
                        onClick={handleSave}
                        disabled={hasErrorsOrNoChanges()}
                    >
                        Salva
                    </button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ReminderModal;